import { createSelector } from '@reduxjs/toolkit';

const selectDescription = (state) => state.video.description;
const videoSlice = {
  getState(state) {
    return state.video;
  },
  videoId(state) {
    return this.getState(state).id;
  },
  isPaused(state) {
    return this.getState(state).state === 'pause';
  },
  isLive(state) {
    return state.video.isLive;
  },
  description: createSelector(selectDescription, (_) => _),
  /**
   * @param {State} state
   * @returns {string[]}
   */
  id_list: createSelector(selectDescription, (description) => {
    const idsSet = new Set([description?.channel_id]);
    if (false === ['tv_linear_vod', 'tv_dvr_vod'].includes(description?.content_type)) {
      idsSet.add(description?.video_id);
    }
    return [...idsSet].filter(Boolean).map((id) => id.toString());
  }),

  extensionConfig: createSelector(
    [(state) => state.video.description, (_, extensionName) => extensionName],
    (objectDescription, extensionName) => {
      return objectDescription?.config?.[extensionName];
    },
  ),
};
export default videoSlice;
